// Sentry initialization should be imported first!
import './sentry';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import App from 'app';
import { persistor, store } from './app/store';
import './index.scss';

const container = document.getElementById('root');

if (container) {
  // Render the React application
  const root = createRoot(container);

  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    </React.StrictMode>,
  );
} else {
  throw new Error(
    // eslint-disable-next-line quotes
    "Root element with ID 'root' was not found in the document. Ensure there is a corresponding HTML element with the ID 'root' in your HTML file.",
  );
}
